import React from 'react';
import './TemplateGridItem.scss';
import { Button, ButtonGroup, Card, CardActions, CardHeader, CardMedia } from '@livingdesign/react';
import { addPreviewCss } from "../../../../../../../utils/template";

export const QA_ID_PREFIX = "TemplateGridItem";

function TemplateGridItem({
  previewHTML = '',
  title = '',
  onUseTemplate = () => {},
  disabled = false,
}) {
  return (
    <Card
      size='medium'
      UNSAFE_className="template-grid-card"
      data-testid={`${QA_ID_PREFIX}-card`}
    >
      <CardMedia
        UNSAFE_className="template-grid-card-media"
        data-testid={`${QA_ID_PREFIX}-card-media`}
      >
        <div
          className="template-preview"
          data-testid={`${QA_ID_PREFIX}-preview`}
          dangerouslySetInnerHTML={{ __html: addPreviewCss(previewHTML) }}
        />
      </CardMedia>
      <CardHeader
        UNSAFE_className="template-grid-card-header"
        title={title}
        data-testid={`${QA_ID_PREFIX}-card-header`}
      />
      <CardActions
        UNSAFE_className="template-grid-card-actions"
        data-testid={`${QA_ID_PREFIX}-card-actions`}
      >
        <ButtonGroup
          UNSAFE_className="template-grid-btn-group"
          data-testid={`${QA_ID_PREFIX}-button-group`}
        >
          <Button
            onClick={onUseTemplate}
            disabled={disabled}
            variant='secondary'
            data-testid={`${QA_ID_PREFIX}-use-template-button`}
          >
            Use template
          </Button>
        </ButtonGroup>
      </CardActions>
    </Card>
  );
}

export default TemplateGridItem;